import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { AccountSettingsService } from "app/main/pages/account-settings/account-settings.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { ProductService } from "services/product.service";
import {
  NgbDateStruct,
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbTimeStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-product-sidebar",
  templateUrl: "./product-sidebar.component.html",
  providers: [NgbCarouselConfig], // add NgbCarouselConfig to the component providers
})
export class ProductSidebarComponent implements OnInit {
  @Input() currentProduct;
  @Input() locations;
  @Input() groups;
  @Input() rows;

  @Output() newItemEvent:EventEmitter<string> = new EventEmitter<string>();
  @Output() loadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // public
  public selected = [];

  public data: any;
  public loadingButton = false;
  public alertClose = true;
  public alert = "Error!";

  public isSmallDisplay = true;

  public MinMaxDPdata: NgbDateStruct;
  public today = new Date().toISOString().slice(0, 10);

  // private
  private _unsubscribeAll: Subject<any>;

  public currentTreatment: any;
  public currentDiscount: any;
  public currentTerm: any;
  public category: any;
  public discountValue = 15;

  // disable
  public disabled: boolean = false;

  /**
   * Constructor
   *
   * @param {CoreSidebarService} _coreSidebarService
   * @param {NgbModal} modalService
   */
  constructor(
    private _productService: ProductService,
    private _coreSidebarService: CoreSidebarService,
    private _httpClient: HttpClient,
    private _accountSettingsService: AccountSettingsService,
    config: NgbCarouselConfig,
    private modalService: NgbModal
  ) {
    this._unsubscribeAll = new Subject();
    config.interval = 0;
  }

  /**
   * Toggle the sidebar
   *
   * @param name
   */
  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    this.addNewItem(this.currentProduct);
    this.alertClose = true;
    this.currentProduct = {
      id: null,
      created_at: null,
      location_id: [],
      title: "",
      description: "",
      hasSetupFee: false,
      setupFee: 0,
      startDate: this.today,
      endDate: null,
      servicesProductsDiscounts: {},
      currency: "AUD",
      minPeriod: 12,
      ageFrom: 8,
      ageTo: 65,
      image: "https://i.imgur.com/JvWDeib.jpg",
      status: "inactive",
      pricing: {
        annually: 0,
        monthly: 0,
        weekly: 0,
        fortnightly: 0,
      },
      treatment: [
        {
          title: "Dental Exams",
          annualQuantity: 2,
          score: 100,
          waitingPeriod: 6,
          specificTermsConditions: "No terms",
          procedures: [
            {
              id: 1,
              name: "Comprehensive oral examination",
            },
            {
              id: 2,
              name: "Periodic oral examination",
            },
          ],
        },
      ],
      generalTerms: [
        {
          title: "General",
          content: "",
        },
      ],
    };

    setTimeout(() => {
      this.loadingChange.emit(false);
    }, 1500);
  
  }

  /**
   * Submit
   *
   * @param form
   */
  submit(form) {

    if (form.valid) {
      this.loadingButton = true;  
      if(this.currentProduct.generalTerms[0].content == "") {
        this.currentProduct.generalTerms[0].content = 'This agreement is not subject to any specific terms and conditions.';
      };  
      if(this.currentProduct.id == null){
        return new Promise((resolve, reject) => {
          this._httpClient
            .post(`${environment.apiUrl}/plan`, this.currentProduct)
            .subscribe(response => {
              resolve(response);
              this.loadingButton = false;
              this.toggleSidebar('product-sidebar'); 
            }, reject);
        })
        .catch((error) => {
          this.loadingButton = false;
          this.alertClose = false;
          this.alert = error;
        })
      }else{
        return new Promise((resolve, reject) => {
          this._httpClient
            .patch(`${environment.apiUrl}/plan`, this.currentProduct)
            .subscribe((response) => {
              resolve(response);
              this.loadingButton = false;
              this.toggleSidebar("product-sidebar");
            }, reject);
        }).catch((error) => {
          this.loadingButton = false;
          this.alertClose = false;
          this.alert = error;
        });
      }
    }
  }

  addNewItem(value: any) {
    this.newItemEvent.emit(value);
  }

  addNewTreatment() {
    this.currentProduct.treatment.push({
      title: "[Click to edit]",
      score: 0,
      annualQuantity: 0,
      procedures: [],
      specificTermsConditions: "No term.",
      waitingPeriod: 0,
    });
  }

  addNewTerm() {
    this.currentProduct.terms.push({
      title: "[Click to edit]",
      content: "",
    });
  }

  print(item) {
    console.log(item);
  }

  switchOffer(idx, modalBD) {
    if (this.currentProduct.servicesProductsDiscounts[idx].discount > 0) {
      this.currentProduct.servicesProductsDiscounts[idx].discount = 0;
      this.currentProduct.servicesProductsDiscounts[idx].offer = false;
      return;
    }
    if (this.rows.category[idx].offer) {
      this.currentProduct.servicesProductsDiscounts[idx].discount = 0;
      this.modalOpenDiscounts(
        modalBD,
        this.currentProduct.servicesProductsDiscounts[idx]
      );
      this.currentProduct.servicesProductsDiscounts[idx].offer = true;
    }
    this.rows.category[idx].offer = !this.rows.category[idx].offer;
  }

  showSavings() {
    this.currentProduct.showSavings = !this.currentProduct.showSavings;
  }

  switchFee(type, freq) {
    if (freq == null) {
      if (this.currentProduct[type] == 0) {
        this.currentProduct[type] = 0.1;
      } else {
        this.currentProduct[type] = 0;
      }
    } else {
      if (this.currentProduct[type][freq] == 0) {
        this.currentProduct[type][freq] = 0.1;
      } else {
        this.currentProduct[type][freq] = 0;
      }
    }
  }

  switchLimit(type) {
    if (type == "ageLimit") {
      if (this.currentProduct["ageTo"] == 0) {
        this.editingTerm(60, "ageTo");
        this.editingTerm(15, "ageFrom");
      } else {
        this.editingTerm(0, "ageTo");
        this.editingTerm(0, "ageFrom");
      }
    } else {
      if (this.currentTreatment[type] == 0) {
        this.editingData(1, type);
      } else {
        this.editingData(0, type);
      }
    }
  }

  deleteItem(type) {
    switch (type) {
      case "product":
        this.currentProduct.status = 'deleted';
        this.modalService.dismissAll("YES");

        new Promise((resolve, reject) => {
          this._httpClient.patch(`${environment.apiUrl}/plan`, this.currentProduct)          
          .subscribe((response) => {
              //this.addNewItem(response);
              resolve(response);
              this.loadingButton = false;
              this.toggleSidebar("product-sidebar");
            }, reject);
          }).catch((error) => {
            this.loadingButton = false;
            this.alertClose = false;
            this.alert = error;
          });

        break;
      case "treatment":
        this.currentProduct.treatment.splice(this.currentTreatment.index, 1);
        this.modalService.dismissAll("YES");

        break;
      case "term":
        this.currentProduct.terms.splice(this.currentTerm.index, 1);
        this.modalService.dismissAll("YES");

        break;
      default:
        break;
    }
  }

  // modal Open Backdrop Disabled
  modalOpenBD(modalBD, size) {
    this.modalService.open(modalBD, {
      backdrop: true,
      centered: true,
      backdropClass: "dark-backdrop",
      size: size, // size: 'xs' | 'sm' | 'lg' | 'xl'
    });
  }
  // modal Open Treatment
  modalOpenCodes(modalBD, data, index) {
    this.currentTreatment = data;
    this.currentTreatment["index"] = index;
    this.modalOpenBD(modalBD, "lg");
  }
  // modal Open Discounts
  modalOpenDiscounts(modalBD, data) {
    this.currentDiscount = data;
    this.modalOpenBD(modalBD, "lg");
  }
  // modal Open Terms
  modalOpenTerms(modalBD, data, index) {
    this.currentTerm = data;
    this.currentTerm["index"] = index;
    this.modalOpenBD(modalBD, "lg");
  }
  // modal Open Discounts
  modalOpenDeleteItem(modalBD) {
      this.modalOpenBD(modalBD, "md");
  }

  /**
   * Inline editing Age
   *
   * @param event
   * @param item
   */
  editingData(event, item) {
    if (
      item == "score" ||
      item == "annualQuantity" ||
      item == "waitingPeriod"
    ) {
      this.currentTreatment[item] = event;
    }
    if (item == "category") {
      this.currentTreatment.procedures = [];
    }
    if (item == "discount") {
      this.discountValue = event;
    }
  }
  editingDiscount(event, item) {
    this.currentDiscount[item] = event;
  }

  editingTerm(event, item) {
    this.currentProduct[item] = event;
  }

  setDiscount() {
    this.rows.category.forEach((element) => {
      element.offer = true;
      element.discounts = [{ score: 0, discount: this.discountValue }];
      for (
        let i = 0;
        i <= this.currentProduct.servicesProductsDiscounts.length;
        i++
      ) {
        this.currentProduct.servicesProductsDiscounts[i].discount =
          element.discounts[0].discount;
        this.currentProduct.servicesProductsDiscounts[i].offer = element.offer;
      }
    });
  }

  selectAll(obj) {
    switch (obj) {
      case "product":
        this.currentProduct.location_id = this.locations.map((x) => x.id);
        break;
      case "treatment":
        this.currentTreatment.procedures = [];
        this.rows["data"].map((x) => {
          this.currentTreatment.procedures.push(x.code);
        });
        break;

      default:
        break;
    }
  }
  unselectAll(obj) {
    switch (obj) {
      case "product":
        this.currentProduct.location_id = [];
        break;
      case "treatment":
        this.currentTreatment.procedures = [];
        break;

      default:
        break;
    }
  }

  ngOnInit(): void {
    this.isSmallDisplay = window.screen.width < 1000;
    this._accountSettingsService.onSettingsChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response) => {
        this.data = response;
      });
  }
}
